module.exports = __webpack_public_path__ + "img/purple.feb8f8ad.webp";